var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big"},[_vm._m(0),_c('device',{attrs:{"mapAction":_vm.mapAction}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexa"},[_c('img',{staticClass:"topimg",attrs:{"src":require("@/assets/modal/warning.png")}}),_c('div',{staticClass:"h1"},[_vm._v(" 预警信息 ")])])
}]

export { render, staticRenderFns }